import React from "react"
interface AlertProps {
    show: (title : string, body : string) => void
}
const Alert = React.createContext<AlertProps | null>(null)

export { Alert }